module.exports = __webpack_public_path__ + "static/img/napa.5cf7393.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/autoshoplogo/napa.png
// module id = +WYX
// module chunks = 0